import React from "react"

const featuresArr = {
  analyticsOverview: {
    key: 'ana_overview',
    title: `analytics.nav.analyticsOverview`,
    desc: "",
    header: "Overview analytics helps you to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    properties: ['overview your charts and statistics']
  },
  analyticsIssues: {
    key: 'ana_issues',
    title: `analytics.nav.analyticsIssues`,
    desc: "",
    header: "Issues analytics helps you to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    properties: ['overview your charts and statistics']
  },
  analyticsResponses: {
    key: 'ana_responses',
    title: `analytics.nav.analyticsResponses`,
    desc: "",
    header: "Responses analytics helps you to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    properties: ['overview your charts and statistics']
  },
  analyticsInspections: {
    key: 'ana_reports',
    title: `analytics.nav.analyticsInspections`,
    desc: "",
    header: "Reports analytics helps you to Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    properties: ['overview your charts and statistics']
  }
}

export default featuresArr